/**
 * Oculta visualmente todos los botones de pago con PayPal en toda la página.
 * NO elimina la integración: solo los marca como invisibles e inaccesibles
 * (visibility:hidden + pointer-events:none + tamaño 0). Cuando vuelva a estar
 * disponible la cuenta, basta con borrar este script y este CSS para que
 * vuelvan a aparecer.
 *
 * Se cubren tres superficies:
 *  - Dynamic checkout de Shopify (PDP): `.shopify-payment-button__button`
 *    cuyo texto/atributos identifiquen PayPal.
 *  - Wallets/express checkout en cart drawer y cart page.
 *  - Cualquier iframe servido por paypal.com.
 *
 * Usa MutationObserver porque Shopify inyecta estos botones de forma asíncrona
 * tras DOMContentLoaded.
 */
(function () {
  'use strict';

  var HIDDEN_FLAG = 'data-clashivfx-paypal-hidden';
  var HIDE_STYLE =
    'position:absolute!important;width:1px!important;height:1px!important;' +
    'padding:0!important;margin:-1px!important;overflow:hidden!important;' +
    'clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important;' +
    'visibility:hidden!important;pointer-events:none!important;opacity:0!important;' +
    'max-height:0!important;max-width:0!important;';

  function looksLikePayPal(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.hasAttribute(HIDDEN_FLAG)) return false;

    // 1) Atributos directos (Shopify suele exponer data-funding-source en algunos themes).
    var attrFunding = el.getAttribute('data-funding-source');
    if (attrFunding && /paypal/i.test(attrFunding)) return true;

    var dataTestId = el.getAttribute('data-testid') || '';
    if (/paypal/i.test(dataTestId)) return true;

    var ariaLabel = el.getAttribute('aria-label') || '';
    if (/paypal/i.test(ariaLabel)) return true;

    var title = el.getAttribute('title') || '';
    if (/paypal/i.test(title)) return true;

    // 2) Iframes de paypal.com (express checkout, smart buttons embebidos).
    if (el.tagName === 'IFRAME') {
      var src = el.getAttribute('src') || el.getAttribute('data-src') || '';
      var name = el.getAttribute('name') || '';
      if (/paypal\.com/i.test(src) || /paypal/i.test(name)) return true;
    }

    // 3) Texto interno (último recurso). Limitamos a elementos pequeños para
    //    evitar match con textos de descripción "Pagá con PayPal" del producto.
    var tag = el.tagName;
    if (tag === 'BUTTON' || tag === 'A' || tag === 'DIV' || tag === 'SPAN') {
      var text = (el.textContent || '').trim();
      if (text.length > 0 && text.length <= 32 && /paypal/i.test(text)) {
        // Solo dentro de zonas relacionadas a pago para no esconder copy del PDP.
        if (
          el.closest(
            '.shopify-payment-button, .additional-checkout-buttons, [data-shopify="payment-button"], .cart__dynamic-checkout-buttons, .product-form__buttons'
          )
        ) {
          return true;
        }
      }
    }

    return false;
  }

  function hideElement(el) {
    if (!el || el.hasAttribute(HIDDEN_FLAG)) return;
    try {
      el.setAttribute(HIDDEN_FLAG, '1');
      // Conservamos el style original para poder restaurar en el futuro si hace falta.
      var prev = el.getAttribute('style') || '';
      el.setAttribute('data-clashivfx-paypal-prev-style', prev);
      el.setAttribute('style', prev + ';' + HIDE_STYLE);
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('tabindex', '-1');
    } catch (e) {}
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    // Lista amplia de selectores; el filtro lo hace looksLikePayPal.
    var nodes = scope.querySelectorAll(
      'iframe, button, a, .shopify-payment-button__button,' +
        ' [data-funding-source], [data-testid], [aria-label], [title]'
    );
    for (var i = 0; i < nodes.length; i++) {
      if (looksLikePayPal(nodes[i])) hideElement(nodes[i]);
    }
  }

  var rafId = 0;
  function scheduleScan() {
    if (rafId) return;
    rafId = requestAnimationFrame(function () {
      rafId = 0;
      scan(document);
    });
  }

  function init() {
    scan(document);

    try {
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
            scheduleScan();
            break;
          }
          if (
            m.type === 'attributes' &&
            (m.attributeName === 'src' ||
              m.attributeName === 'data-funding-source' ||
              m.attributeName === 'aria-label' ||
              m.attributeName === 'data-testid')
          ) {
            scheduleScan();
            break;
          }
        }
      });
      mo.observe(document.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['src', 'data-funding-source', 'aria-label', 'data-testid', 'title'],
      });
    } catch (e) {}

    // Reescaneos tardíos para wallets que se montan después de window.load.
    setTimeout(scheduleScan, 300);
    setTimeout(scheduleScan, 1500);
    setTimeout(scheduleScan, 4000);

    document.addEventListener('shopify:section:load', scheduleScan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
